import { createSupportMessage } from './createSupportMessageThunk';
export default createSupportMessage;
